type getRelevantStepSequenceProps = {
  steps: string[];
  splitStepsAt: string[];
  currentStep: string;
  excludedSteps?: string[];
};

export const getRelevantStepsSequence = ({
  steps,
  splitStepsAt,
  currentStep,
  excludedSteps,
}: getRelevantStepSequenceProps): string[] => {
  const excludedStepsSet = new Set(excludedSteps || []);
  const filteredSteps = steps.filter(step => !excludedStepsSet.has(step));
  const splitIndexes = splitStepsAt.map(step => filteredSteps.indexOf(step));
  const sortedSplitIndexes = splitIndexes.sort((a, b) => a - b);
  const splitIndexesResults = sortedSplitIndexes.map(index => index + 1);

  const grouper: string[][] = [];
  let lastIndex = 0;

  splitIndexesResults.forEach(index => {
    grouper.push(filteredSteps.slice(lastIndex, index));
    lastIndex = index;
  });

  grouper.push(filteredSteps.slice(lastIndex));
  const results = grouper.find(i => i.includes(currentStep));

  if (!results) {
    throw new Error(`Current step "${currentStep}" not found in steps`);
  }
  return results;
};
